import { render } from "./ImageAnalyzer.vue?vue&type=template&id=4c33f101&scoped=true"
import script from "./ImageAnalyzer.vue?vue&type=script&lang=js"
export * from "./ImageAnalyzer.vue?vue&type=script&lang=js"

import "./ImageAnalyzer.vue?vue&type=style&index=0&id=4c33f101&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c33f101"]])

export default __exports__